module.exports = __webpack_public_path__ + "static/media/investorAvatar.b6ecc92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/investorAvatar.png
// module id = 920
// module chunks = 0